import { useState } from "react";
import { Card } from "react-bootstrap";

const RadioButtonViewAll = ({ filterName, defaultCheckedFlag, onChange, heading, filterKeyword, closeFilter, optionValue, defaultActiveSate }) => {
  const [defaultValue, setDefaultValue] = useState(typeof defaultCheckedFlag === "boolean" ? defaultCheckedFlag : defaultActiveSate);
  const [option] = useState(optionValue);

  const setDefaultValueHandler = (value) => {
    setDefaultValue(value);
  };

  const onApplyHandler = () => {
    onChange(typeof defaultValue === "boolean" ? defaultValue : false, filterKeyword, option);
  };

  return (
    <Card className="range-view-all-card" onClick={(e) => e.stopPropagation()}>
      <Card.Header>
        <div className="d-flex">
          <div className="col-md-5 pl-0">
            <h1 className="header-styling ml-3"> {heading ? heading : ""}</h1>
            {/* <input className="form-control" type="text" placeholder={placeholder} onChange={e => onSearch(e.target.value)}></input> */}
          </div>
          <div className="col-md-5 pl-0" />
          <div className="col-md-2 text-right pr-0">
            <button
              type="button"
              className="btn btn-primary btn-sm trademo-new-btn"
              onClick={() => {
                onApplyHandler();
                // callForFilter
              }}>
              Apply Filter
            </button>
            <button type="button" className="close trademo-modal-close" aria-label="Close" onClick={closeFilter.bind(this, filterKeyword)}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="ml-2">
        <div
          onChange={(e) => {
            setDefaultValueHandler(e.target.value === "true");
          }}
          className="custom-right-radio">
          <div className="form-check">
            <input className="form-check-input" type="radio" name={"radio" + filterName} id={"radio" + option.optionOne} value={true} defaultChecked={defaultCheckedFlag !== undefined ? defaultValue : true} />
            <span className="pseudo-checkmark" />
            <label className="form-check-label" htmlFor={"radio" + option.optionOne}>
              {option.optionOne ? option.optionOne : ""}
            </label>
          </div>
          <div className="form-check">
            <input className="form-check-input" type="radio" name={"radio" + filterName} id={"radio" + option.optionTwo} value={false} defaultChecked={defaultCheckedFlag !== undefined ? !defaultValue : false} />
            <span className="pseudo-checkmark" />
            <label className="form-check-label" htmlFor={"radio" + option.optionTwo}>
              {option.optionTwo ? option.optionTwo : ""}
            </label>
          </div>
        </div>
        {option.disclaimer1 ? (
          <p className="mt-4 mb-0">
            <i>*{option.disclaimer1}</i>
          </p>
        ) : null}
        {option.disclaimer2 ? (
          <p className="mt-2 mb-0">
            <i>*{option.disclaimer2}</i>
          </p>
        ) : null}
      </Card.Body>
    </Card>
  );
};

export default RadioButtonViewAll;
